import { gql } from "@apollo/client";

export const GET_BRANCHES = gql`
  query GetBranches {
    getBranches {
      id
      address
      name
      phone
      is_main
    }
  }
`;

export const GET_PARTNER = gql`
  query GetPartner {
    getPartner {
      id
      about
      short_desc
      fb_page
      instagram
      webpage
      url_name
    }
  }
`;

export const GET_SHIPPING_COSTS = gql`
  query GetShippingCosts {
    getShippingCosts {
      id
      price
      distance
      status
    }
  }
`;

export const ADD_SHIPPING_COST = gql`
  mutation AddShippingCost($data: ShippingCostInput!) {
    addShippingCost(data: $data) {
      id
      price
      distance
      status
    }
  }
`;

export const UPDATE_SHIPPING_COST = gql`
  mutation UpdateShippingCost($data: ShippingCostInput!) {
    updateShippingCost(data: $data) {
      id
      price
      distance
      status
    }
  }
`;

export const DELETE_SHIPPING_COST = gql`
  mutation DeleteShippingCost($id: ID!) {
    deleteShippingCost(id: $id)
  }
`;
